<div class="container">
    <div class="w-full flex flex-row justify-between">
        <h5 class="ml-1">{{label}}</h5>
        <button nz-button nzType="default" nzShape="round" (click)="addable = !addable" *ngIf="!addable">
            <i class="fa-solid fa-plus"></i>&nbsp;New Note
        </button>
    </div>
    <portals-provider-add-note
        *ngIf="addable"
        [consultation]="consultation"
        [order]="order"
        [subscription]="subscription"
        (cancelled)="closeComposer()"
    ></portals-provider-add-note>
    <portals-provider-note-item
        *ngFor="let item of notes$ | async | keyvalue : noteOrder"
        [note]="item.value"
    ></portals-provider-note-item>

    <div class="toolbar">
        <p>
            Total: {{ (totalCount$ | async) || 'No' }} note{{
                (totalCount$ | async) > 1 ? 's' : ''
            }}
        </p>
    </div>
</div>
